export const CHANGE_EDITERMODE = "CHANGE_EDITERMODE";
export const CHANGE_SWMODE = "CHANGE_SWMODE";
export const CHANGE_REGMODE = "CHANGE_REGMODE";
export const CHANGE_INPREDICT = "CHANGE_INPREDICT";
export const CHANGE_INEXEWAITING = "CHANGE_INEXEWAITING";
export const CHANGE_WATINGTIME = "CHANGE_WATINGTIME";
export const FIN_LRN = "FIN_LRN";
export const CHANGE_LOCINFO = "CHANGE_LOCINFO";
export const CHANGE_DIST = "CHANGE_DIST";
export const CHANGE_POSTAB = "CHANGE_POSTAB";
export const CHANGE_PRETAB = "CHANGE_PRETAB";
export const CHANGE_RSLTTAB = "CHANGE_RSLTTAB";
export const CHANGE_LAYEROPA = "CHANGE_LAYEROPA";
export const SET_USERLICENSE = "SET_USERLICENSE";
export const SET_MODULETABLE = "SET_MODULETABLE";
export const CHANGE_ISSTART = "CHANGE_ISSTART";
export const CHANGE_ISBUSYS = "CHANGE_ISBUSYS";
export const CHANGE_ISBUSYC = "CHANGE_ISBUSYC";
export const CHANGE_IMPWS = "CHANGE_IMPWS";
export const CHANGE_DATADWONLOAD = "CHANGE_DATADWONLOAD";
export const SET_GMURL = "SET_GMURL";

export function changeEditerModeAction(mode) {
  return {
    type: CHANGE_EDITERMODE,
    mode: mode,
  };
}

export function changeSwModeAction(mode) {
  return {
    type: CHANGE_SWMODE,
    mode: mode,
  };
}

export function changeRegModeAction(mode) {
  return {
    type: CHANGE_REGMODE,
    mode: mode,
  };
}

export function changeInPredictAction(value) {
  return {
    type: CHANGE_INPREDICT,
    value: value,
  };
}

export function changeInExeWaitngAction(value) {
  return {
    type: CHANGE_INEXEWAITING,
    value: value,
  };
}

export function changeWaitngTimeAction(value) {
  return {
    type: CHANGE_WATINGTIME,
    value: value,
  };
}

export function finLrnAction(isFin) {
  return {
    type: FIN_LRN,
    isFin: isFin,
  };
}

export function changeLocInfoAction(coords) {
  return {
    type: CHANGE_LOCINFO,
    coords: coords,
  };
}

export function changeDistAction(dist) {
  return {
    type: CHANGE_DIST,
    dist: dist,
  };
}

export function changePosTabAction(value) {
  return {
    type: CHANGE_POSTAB,
    value: value,
  };
}

export function changePreTabAction(value) {
  return {
    type: CHANGE_PRETAB,
    value: value,
  };
}

export function changeRsltTabAction(value) {
  return {
    type: CHANGE_RSLTTAB,
    value: value,
  };
}

export function changeLayerOpaAction(value) {
  return {
    type: CHANGE_LAYEROPA,
    value: value,
  };
}

export function setUserLicenseAction(value) {
  console.log(value);
  return {
    type: SET_USERLICENSE,
    value: value,
  };
}

export function setModeleTableAction(value) {
  return {
    type: SET_MODULETABLE,
    value: value,
  };
}

export function changeIsStartAction(value) {
  return {
    type: CHANGE_ISSTART,
    value: value,
  };
}

export function changeIsBusySAction(value) {
  return {
    type: CHANGE_ISBUSYS,
    value: value,
  };
}

export function changeIsBusyCAction(value) {
  return {
    type: CHANGE_ISBUSYC,
    value: value,
  };
}

export function changeImpWSAction(value) {
  return {
    type: CHANGE_IMPWS,
    value: value,
  };
}

export function changedataDownloadAction(value) {
  return {
    type: CHANGE_DATADWONLOAD,
    value: value,
  };
}

export function setGMUrlAction(value) {
  return {
    type: SET_GMURL,
    value: value,
  };
}
